<template>
  <div>
    <hora>
        <div class="form" :style="{borderColor: icc}">
          <div class="form-field-group">
            <div class="form-field">
              <label>Track</label>
              <input type="text" v-model="track"/>
            </div>
            <div class="form-field">
              <label>Kunde</label>
              <input type="text" v-model="customer"/>
            </div>
            <div class="form-field">
              <label>Projekt</label>
              <input type="text" v-model="project"/>
            </div>
            <div class="form-field">
              <label>Kennung</label>
              <input type="text" v-model="identifier"/>
            </div>
          </div>
          <div class="form-field-group">
            <div class="form-field">
              <label>Codename</label>
              <input type="text" v-model="codename"/>
            </div>
            <div class="form-field">
              <label>ICC (bitte nur als HEX-Wert)</label>
              <input type="text" v-model="icc"/>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link tag="button" :style="{backgroundColor: icc}" :to="{name: 'user_home'}"><i class="material-icons">close</i></router-link>
          <button :style="{backgroundColor: icc}" @click="save"><i class="material-icons">check</i></button>
        </div>
    </hora>
  </div>
</template>

<script>
  import Hora from '@/layouts/Hora.vue'
  import AutoTextarea from '@/components/AutoTextarea.vue'
  import Entries from '@/components/Entries.vue';

export default {
  name: 'project_start',
  components: {Hora},
  data() {
    return {
      customer: null,
      project: null,
      identifier: null,
      codename: null,
      icc: null,
      track: null
    }
  },
  methods: {
    save() {
      this.$store.dispatch('addProject', {
        identifier: this.identifier,
        customer: this.customer,
        project: this.project,
        codename: this.project,
        icc: this.icc,
        track: this.track,
        last_activity: [2000, 1, 1]
      });
      this.$router.push({name: 'user_home'});
    }
  }
}
</script>


<style lang="sass" scoped>
    button.timer
      text-align: center
      color: white
      border-radius: 100%
      border: 0
      display: block
</style>
